import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from '@material-ui/styles';
import validate from 'validate.js';

import './i18n';
import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.module.scss';
import validators from './common/validators';
import Routes from './Routes';
import i18n from 'i18next';
import axios from 'axios';
import auth from './utils/auth';

import 'mapbox-gl/dist/mapbox-gl.css';


const browserHistory = createBrowserHistory();

/*
Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});
쿠키 불러와서 언어번역
*/
if(auth.getToken() !== null) { 

  let auth_str = 'Bearer '.concat((auth.getToken().token)); 

  axios.get(
    `${process.env.REACT_APP_RESTAPI_BASE_URL}/json-api/get-preferences.php`, 
    { 
      headers: { Authorization: auth_str }, 
      params: { 
        order:'preferences'
      }
    }
  ).then(function (response) {
    const preferences = response.data;
//    console.log(preferences);
    i18n.changeLanguage(preferences.lang);
    
  }).catch(function (err) {
    console.log(err);
  })
}

validate.validators = {
  ...validate.validators,
  ...validators
};

export default class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <Router history={browserHistory}>
          <Routes />
        </Router>
      </ThemeProvider>
    );
  }
}
